export enum ModalTypes {
  ActivateCustomerModal,
  ActivateUserModal,
  AddCanvasModal,
  AddScheduleModal,
  ArchiveCustomerModal,
  ArchiveUserModal,
  AssetAuditLogModal,
  AssetUploadModal,
  DeleteAssetModal,
  DeleteCanvasModal,
  DeletePlaylistAssetModal,
  DeletePlaylistModal,
  DeleteSchedulModal,
  DeleteUserModal,
  HeaderModal,
  LogoutModal,
  SchedulePlaylistModal,
  UpdateCanvasModal,
  UpdateCustomerModal,
  UpdateScheduleModal,
  UpdateUserModal,
}
